export const sessionHelper = {
  methods: {
    async logout() {
      try {
        // Call the API logout endpoint first
        await this.$session.authApi.logout()
        // Then proceed with local cleanup
        localStorage.removeItem('ONBOARD_DATA')
        this.$ma.reset()
        this.$eventBus.$emit('destroy-cart')
        this.$eventBus.$emit('unsubscribe-all')
        this.$store.commit('removeCheckoutState')
        this.$store.commit('clearUserState')
        if (window.talkSession) {
          window.talkSession.destroy()
        }
        this.$session.destroy()
        if (this.$route.name === undefined || this.$route.name === 'home') {
          window.location.reload()
        } else {
          this.$router.push('/home')
          this.$forceUpdate()
        }
      } catch (error) {
        console.error('Logout failed:', error)
        // Still destroy the local session even if API call fails
        this.$store.commit('clearUserState')
        this.$session.destroy()
        this.$router.push('/home')
      }
    }
  }
}
